import React, { Component } from 'react';
import cx from 'classnames';
import FontFaceObserver from 'fontfaceobserver';
import WithNavigation from '../../common/WithNavigation';
import fontWeightMap from '../../../constants/fontMap';
import {
  TopLeft,
  TopMiddle,
  TopRight,
  MiddleLeft,
  Middle,
  MiddleRight,
  BottomLeft,
  BottomMiddle,
  BottomRight,
} from '../../../constants/rowTextPositions';
import { getFontNameFromGoogleFontUrl } from '../../../helpers/fonts';
import urlNormalizer from '../../../helpers/urlNormalizer';
import styles from './styles.scss';

const rowPositionClassMap = {
  [TopLeft]: ['topLabel', 'leftLabel'],
  [TopMiddle]: ['topLabel', 'middleLabel'],
  [TopRight]: ['topLabel', 'rightLabel'],
  [MiddleLeft]: ['centerLabel', 'leftLabel'],
  [Middle]: ['centerLabel', 'middleLabel'],
  [MiddleRight]: ['centerLabel', 'rightLabel'],
  [BottomLeft]: ['bottomLabel', 'leftLabel'],
  [BottomMiddle]: ['bottomLabel', 'middleLabel'],
  [BottomRight]: ['bottomLabel', 'rightLabel'],
};

class StandardFormatData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedRowItemFont: null,
    };
  }

  componentDidMount() {
    if (this.props.rowItem.font) {
      const rowItemFont = new FontFaceObserver(getFontNameFromGoogleFontUrl(this.props.rowItem.font.url));
      rowItemFont.load(null, 6000).then((loadedFont) => this.setState({
        uploadedRowItemFont: loadedFont,
      }));
    }
  }

  getRowItemTextWithStyles = (
    isTrackingPageFontExisted,
    uploadedTrackingPageFont,
    font,
    trackingPageFont,
    rowTextPosition,
    textToDisplay,
    redirectionUrl,
  ) => {
    const labelStyles = [
      'itemLabel',
      ...rowPositionClassMap[rowTextPosition],
    ].map((style) => styles[style]).join(' ');
    let fontStyles;
    if (font) {
      fontStyles = {
        fontSize: font.size,
        fontWeight: fontWeightMap[font.fontWeight],
        color: font.colour,
      };
      if (this.state.uploadedRowItemFont) {
        fontStyles.fontFamily = this.state.uploadedRowItemFont.family;
      }
    } else if (trackingPageFont && uploadedTrackingPageFont) {
      fontStyles = {
        fontSize: trackingPageFont.size,
        fontWeight: fontWeightMap[trackingPageFont.fontWeight],
        color: trackingPageFont.colour,
        fontFamily: uploadedTrackingPageFont.family,
      };
    }

    if (!font && !isTrackingPageFontExisted) {
      return this.renderTextLabel(
        redirectionUrl,
        textToDisplay,
        labelStyles,
      );
    }
    if (!font && uploadedTrackingPageFont) {
      return this.renderTextLabel(
        redirectionUrl,
        textToDisplay,
        labelStyles,
        fontStyles,
      );
    }
    if (font && ((font.url && this.state.uploadedRowItemFont) || !font.url)) {
      return this.renderTextLabel(
        redirectionUrl,
        textToDisplay,
        labelStyles,
        fontStyles,
      );
    }
    return '';
  };

  renderTextLabel = (redirectionUrl, text, labelStyles, fontStyle) => (
    redirectionUrl
      ? (
        <a href={urlNormalizer.normalize(redirectionUrl)} style={fontStyle} className={labelStyles}>
          {text}
        </a>
      )
      : <p className={cx(labelStyles, styles.inactiveLabel)} style={fontStyle}>{text}</p>
  );

  render() {
    const {
      rowItem: {
        font,
        redirectionUrl,
        rowTextPosition,
        text,
      },
      isTrackingPageFontExisted,
      uploadedTrackingPageFont,
      trackingPageFont,
    } = this.props;

    return (
      <div className={styles.standartItemContainer}>
        {this.props.rowItem.base64Image
        && (
        <WithNavigation
          url={redirectionUrl}
          navigationClass={styles.itemImageLink}
        >
          <img alt="" src={`data:image/png;base64,${this.props.rowItem.base64Image}`} />
        </WithNavigation>
        )}
        {
          this.getRowItemTextWithStyles(
            isTrackingPageFontExisted,
            uploadedTrackingPageFont,
            font,
            trackingPageFont,
            rowTextPosition,
            text,
            redirectionUrl,
          )
          }
      </div>
    );
  }
}

export default StandardFormatData;
